// @flow
import styles from './PromoBadge.scss';

// TODO: https://gitlab.corp.gandi.net/gandi/squad-shop/app-shop/-/issues/170
export function PromoBadge(): React.MixedElement {
  return (
    <div className={styles.banner}>
      <span className={styles.sparkle}>✨</span> Good news!{' '}
      <span className={styles.highlight}>
        You’re saving €4,50 on your order!
      </span>{' '}
      <span className={styles.sparkle}>✨</span>
    </div>
  );
}
